(function($) {

	// Wait for document to get ready.
	$(document).ready(function() {

		// Create a mutation observer.
		var hyphenObserver = new MutationObserver(function (mutations) {

			// Loop over mutations.
			mutations.forEach(function(mutation) {

				// If nodes where added.
				if(mutation.addedNodes) {
					// Loop over each added node.
					for(var elementIndex in mutation.addedNodes) {
						//
						if(!mutation.addedNodes.hasOwnProperty(elementIndex)) {
							continue;
						}

						//
						var element = mutation.addedNodes[elementIndex];
						var $element = $(element);

						//
						if($element.hasClass('unit-name') || element.tagName === "H1") {
							element.innerHTML = element.innerHTML.replace(/([sl])(direktoriet)/ig, '$1&shy;$2');
							element.innerHTML = element.innerHTML.replace(/(frimurar[e]?)(stiftelse)/ig, '$1&shy;$2');
							element.innerHTML = element.innerHTML.replace(/(bidrags)(verksamhet)/ig, '$1&shy;$2');
							element.innerHTML = element.innerHTML.replace(/(barmhärtighets)(verksamhet)/ig, '$1&shy;$2');
							element.innerHTML = element.innerHTML.replace(/(åtgärds)(program)/ig, '$1&shy;$2');
							element.innerHTML = element.innerHTML.replace(/(medlems)(utveckling)/ig, '$1&shy;$2');
						} else {
							$element.find('.unit-name, h1').each(function(unitNameIndex, unitNameElemet) {
								unitNameElemet.innerHTML = unitNameElemet.innerHTML.replace(/([sl])(direktoriet)/ig, '$1&shy;$2');
								unitNameElemet.innerHTML = unitNameElemet.innerHTML.replace(/(frimurar[e]?)(stiftelse)/ig, '$1&shy;$2');
								unitNameElemet.innerHTML = unitNameElemet.innerHTML.replace(/(bidrags)(verksamhet)/ig, '$1&shy;$2');
								unitNameElemet.innerHTML = unitNameElemet.innerHTML.replace(/(barmhärtighets)(verksamhet)/ig, '$1&shy;$2');
								unitNameElemet.innerHTML = unitNameElemet.innerHTML.replace(/(åtgärds)(program)/ig, '$1&shy;$2');
								unitNameElemet.innerHTML = unitNameElemet.innerHTML.replace(/(medlems)(utveckling)/ig, '$1&shy;$2');
							})
						}
					}
				}
			});
		});

		var config = {
			subtree: true,
			childList: true
		};

		$('[snippet="UnitInfo"], [snippet="EditorialMaterialDetailPage"], [snippet="EditorialMaterialListPage"], [snippet="Instruction"], [snippet="SignUp"], [snippet="MeetingsPerUnit"]').each(function(snippetIndex, snippet) {
			// Start observing.
			hyphenObserver.observe(snippet, config);
		});

	});
})(window.jQuery);
